import React, { memo, useEffect, useState } from 'react';
import classnames from 'classnames';

import './styles/Header.css';
import { useTranslation } from "react-i18next";

export const Header = memo(() => {
  const { t, i18n } = useTranslation();

  const menu = [
    { text: 'menu.about', anchor: 'o-nas' },
    { text: 'menu.values', anchor: 'wartości' },
    { text: 'menu.howWeWork', anchor: 'dzialamy' },
    { text: 'menu.larps', anchor: 'larps' },
    { text: 'menu.gallery', anchor: 'galeria' },
    { text: 'menu.characters', anchor: 'postacie' },
    { text: 'menu.links', anchor: 'linki' },
  ];

  const LANG_KEY = "app_lang";

  const languages = [
    { code: "pl", label: "PL", flag: "🇵🇱" },
    { code: "en", label: "EN", flag: "🇬🇧" },
  ];

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState(menu[0].anchor);

  const [langOpen, setLangOpen] = useState(false);
  const [currentLang, setCurrentLang] = useState(i18n.language || "pl");

  const handleItemClick = (anchor) => {
    setIsMenuOpen(false);
    setActiveMenu(anchor);
  };

  useEffect(() => {
    const hash = window.location.hash.replace('#', '');
    setActiveMenu(hash || menu[0].anchor);
  }, []);

  // Load saved language on mount
  useEffect(() => {
    const savedLang = localStorage.getItem(LANG_KEY);
    if (savedLang) {
      i18n.changeLanguage(savedLang);
      setCurrentLang(savedLang);
    }
  }, [i18n]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setCurrentLang(lng);
    localStorage.setItem(LANG_KEY, lng);
    setLangOpen(false);
  };

  return (
    <>
      <div className="header">
        <h2 className="title">
          <img className="logo" src="logo.jpg" alt="Zlote Lwy Marienburga" />
          <img className="logo-name" src="logo-lwy.jpeg" alt="Zlote Lwy Marienburga" />
        </h2>

        <button
          className={classnames("burger", {
            'is-open': isMenuOpen
          })}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <span></span><span></span><span></span>
        </button>

        <div className={classnames("toggle-menu", {
          'is-open': isMenuOpen
        })}>
          <ul className="menu">
            {menu.map(item => (
              <li key={item.anchor} className="menu-item">
                <a
                  href={`#${item.anchor}`}
                  className={classnames("menu-item-link", {
                    'is-active': item.anchor === activeMenu
                  })}
                  onClick={() => handleItemClick(item.anchor)}
                >
                  {t(item.text)}
                </a>
              </li>
            ))}
          </ul>

          {/* LANGUAGE DROPDOWN */}
          <div className="lang-dropdown">
            <button
              className="lang-dropdown-btn"
              onClick={() => setLangOpen(!langOpen)}
            >
              <span className="flag">
                {languages.find(l => l.code === currentLang)?.flag}
              </span>
              <span className="code">
                {languages.find(l => l.code === currentLang)?.label}
              </span>
              <span className="arrow">▼</span>
            </button>

            {langOpen && (
              <div className="lang-dropdown-menu">
                {languages.map(lang => (
                  <button
                    key={lang.code}
                    className={classnames("lang-item", {
                      active: currentLang === lang.code
                    })}
                    onClick={() => changeLanguage(lang.code)}
                  >
                    <span className="flag">{lang.flag}</span>
                    <span>{lang.label}</span>
                  </button>
                ))}
              </div>
            )}
          </div>

          <a
            className="button button-link"
            href="https://www.facebook.com/lwymarienburga"
            target="_blank"
            rel="noreferrer"
          >
            {t("header.joinUs")}
          </a>
        </div>
      </div>

      <div
        className={classnames("overlay", { 'is-visible': isMenuOpen })}
        onClick={() => setIsMenuOpen(false)}
      />
    </>
  );
});

export default Header;